module.exports = __webpack_public_path__ + "static/media/ninjaBucks.7a62fded.webp";